/** @jsxImportSource @emotion/react */
import { Box, FlexLayout } from '@deity/falcon-ui';
import type React from 'react';
import { isMobile } from 'react-device-detect';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import SchemaField from './SchemaField';

type SchemaViewProps = {
  packageVersionUuid?: string;
  schema: any;
  field: string;
  selectedField?: Array<string>;
  onSelect?: (path: Array<string>) => void;
  onToggleChecked?: (path: Array<string>, checked: boolean) => void;
  checkedFields?: Array<string>;
};
const SchemaView: React.FC<SchemaViewProps> = ({
  packageVersionUuid,
  schema,
  field,
  selectedField,
  onSelect,
  onToggleChecked,
  checkedFields
}) => (
  <Box height="full">
    <DndProvider backend={isMobile ? TouchBackend : HTML5Backend}>
      <div
        css={{
          height: '100%',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <FlexLayout
          height="full"
          width="full"
          bg="white"
          flexDirection="column"
          justifyContent="space-between"
          css={{
            boxSizing: 'border-box'
          }}
        >
          <Box
            css={{
              height: '100%',
              overflowY: 'auto',
              overflowX: 'hidden',
              minHeight: '96px',
              paddingBottom: '2em'
            }}
          >
            <SchemaField
              path={[]}
              packageVersionUuid={packageVersionUuid}
              field={field}
              isEditable={false}
              selectedField={selectedField || []}
              schema={schema}
              onToggleChecked={onToggleChecked}
              checkedFields={checkedFields}
              onSelect={path => {
                if (onSelect) {
                  onSelect(path);
                }
              }}
            />
          </Box>
        </FlexLayout>
      </div>
    </DndProvider>
  </Box>
);

export default SchemaView;
